import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { IMAGES } from "../lib/images";
import { Reveal, useSEO } from "../components/site/Reveal";
import Newsletter from "../components/site/Newsletter";
import api from "../lib/api";

export default function OrisaEncyclopedia() {
  useSEO(
    "Òrìṣà Encyclopedia",
    "An encyclopedia of the Òrìṣà — the divine forces of Yorùbá spirituality. Explore Ọbàtálá, Ṣàngó, Ọ̀ṣun, Ògún, Yemọja, and more."
  );

  const [orisa, setOrisa] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [banner, setBanner] = React.useState("");
  React.useEffect(() => { api.get("/site-settings").then((r) => { if (r.data?.banner_orisa) setBanner(r.data.banner_orisa); }).catch(() => {}); }, []);

  React.useEffect(() => {
    api.get("/orisa").then((r) => setOrisa(r.data || [])).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="bg-night text-cream">
      <header className="relative min-h-[56vh] flex items-end grain-overlay">
        <div className="absolute inset-0">
          <img src={banner || IMAGES.woodCarving} alt="Òrìṣà carvings" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-night via-night/80 to-night/50" />
        </div>
        <div className="relative max-w-6xl mx-auto px-6 pb-16 w-full">
          <p className="uppercase tracking-[0.3em] text-xs text-gold-soft mb-5">Deep Knowledge</p>
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
            className="font-serif text-5xl lg:text-6xl leading-tight text-shadow-hero"
          >
            Òrìṣà Encyclopedia
          </motion.h1>
          <p className="mt-5 text-cream/75 text-lg max-w-2xl">
            The Òrìṣà are the divine forces of the Yorùbá universe — each governing an aspect of
            nature and human life, served as pathways to Olódùmarè, the Supreme Being.
          </p>
        </div>
      </header>

      <section className="max-w-6xl mx-auto px-6 py-20">
        {loading ? (
          <p className="text-cream/60 text-center py-16" data-testid="orisa-loading">Loading…</p>
        ) : orisa.length === 0 ? (
          <p className="text-cream/60 text-center py-16" data-testid="orisa-empty">No Òrìṣà entries yet.</p>
        ) : (
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {orisa.map((o, i) => (
              <Reveal key={o.id || o.slug} delay={(i % 3) * 0.06}>
                <Link to={`/orisa/${o.slug}`} data-testid={`orisa-link-${o.slug}`} className="block h-full">
                  <article
                    className="group h-full border border-cream/10 rounded-xl overflow-hidden bg-night-surface hover:border-gold/60 transition-colors"
                    data-testid={`orisa-card-${o.name}`}
                  >
                    <div className="h-52 overflow-hidden relative">
                      {o.image && <img src={o.image} alt={o.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />}
                      <div className="absolute inset-0 bg-gradient-to-t from-night-surface to-transparent" />
                    </div>
                    <div className="p-7">
                      {o.color && <p className="text-xs uppercase tracking-widest text-gold-soft mb-2">{o.color}</p>}
                      <h2 className="font-serif text-3xl text-cream mb-1">{o.name}</h2>
                      {o.domain && <p className="text-sm text-gold mb-4">{o.domain}</p>}
                      <p className="text-cream/70 leading-relaxed">{o.description}{o.description ? " " : ""}<span className="text-gold-soft">Read the full profile →</span></p>
                    </div>
                  </article>
                </Link>
              </Reveal>
            ))}
          </div>
        )}
      </section>

      <Newsletter />
    </div>
  );
}
